import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  fetchResourcesSuccess,
  fetchResourcesFailure,
  saveResourceSuccess,
  saveResourceFailure,
  updateResourceSuccess,
  updateResourceFailure,
  deleteResourceSuccess,
  deleteResourceFailure,
} from "./actions";
import {
  fetchResources,
  saveResource,
  updateResource,
  deleteResource,
} from "./resources";

// 🔹 Fetch Resources
function* fetchResourcesSaga(action) {
  try {
    const { _id, callback } = action.payload;
    const data = yield call(fetchResources, _id);

    yield put(fetchResourcesSuccess(data?.data || []));
    if (typeof callback === "function") {
      callback({ type: 1, data: data?.data });
    }
  } catch (error) {
    yield put(fetchResourcesFailure(error.message));
    if (action.payload?.callback) {
      action.payload.callback({ type: 0, error: error.message });
    }
  }
}

// 🔹 Save Resource
function* saveResourceSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveResource, apiPayloadRequest);

    // ✅ Normalize the saved resource to match reducer expectation
    const savedResource = {
      ...apiPayloadRequest,
      resourceObjId: data?.resourceObjId || data?.data?.resourceObjId,
    };

    yield put(saveResourceSuccess(savedResource));

    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: savedResource });
    }
  } catch (error) {
    yield put(saveResourceFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

// 🔹 Update Resource
function* updateResourceSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(updateResource, apiPayloadRequest);

    const updatedResource = {
      ...apiPayloadRequest,
      ...data?.data, // merge backend response if any
    };

    yield put(updateResourceSuccess(updatedResource));

    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: updatedResource });
    }
  } catch (error) {
    yield put(updateResourceFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

// 🔹 Delete Resource
function* deleteResourceSaga(action) {
  try {
    const { _id, resourceObjId, callback } = action.payload;
    const data = yield call(deleteResource, { _id, resourceObjId });

    if (data?.type === 1) {
      yield put(deleteResourceSuccess({ resourceObjId }));
      if (callback) callback({ type: 1, data: { resourceObjId } });
    } else {
      yield put(deleteResourceFailure(data?.message || "Delete failed"));
      if (callback) callback({ type: 0, error: data?.message });
    }
  } catch (error) {
    yield put(deleteResourceFailure(error.message));
    if (action.payload?.callback) {
      action.payload.callback({ type: 0, error: error.message });
    }
  }
}

export default function* resourcesWatcherSaga() {
  yield takeLatest(actionTypes.FETCH_RESOURCES_REQUEST, fetchResourcesSaga);
  yield takeLatest(actionTypes.SAVE_RESOURCE_REQUEST, saveResourceSaga);
  yield takeLatest(actionTypes.UPDATE_RESOURCE_REQUEST, updateResourceSaga);
  yield takeLatest(actionTypes.DELETE_RESOURCE_REQUEST, deleteResourceSaga);
}
